import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import { locale } from '../../utils/i18n';
import OverlayWrap from '../OverlayWrap';
import { staticPath, getKey, isObject, isValidUrl } from '../../utils/common';
import { get } from '../../../../common/src/utils/http';
import CONSTANT, { CACHE } from '../../utils/constants';

class Offers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      offers: [],
      areOffersVisible: false,
      isTermsAndCondistionVisible: false,
      termsAndConditions: null
    };
  }

  componentDidMount() {
    this.setState({
      offers: getKey(this.props.cache.getData(CACHE.PAYMENT_OPTIONS), 'paymentOffers', [])
    });
  }

  toggleOffersVisibility = () => {
    this.setState(prevState => ({
      areOffersVisible: !prevState.areOffersVisible
    }));
  };

  closeTermsAndConditions = () => {
    this.setState(prevState => ({
      isTermsAndCondistionVisible: !prevState.isTermsAndCondistionVisible
    }));
  };

  showTermsAndConditions = (url, termsTitle) => {
    this.setState(prevState => ({
      isTermsAndCondistionVisible: !prevState.isTermsAndCondistionVisible,
      termsAndConditions: {
        termsTitle
      }
    }));

    if (isValidUrl(url)) {
      get(url, { noQueryParam: true })
        .then(termsAndConditions => {
          this.setState({
            termsAndConditions: isObject(termsAndConditions) ? termsAndConditions : { termsTitle }
          });
        })
        .catch(error => {
          this.setTermsAndConditionError(
            getKey(error, 'message', CONSTANT.GENERIC_ERROR),
            termsTitle
          );
        });
    } else {
      this.setTermsAndConditionError(locale('offers.invalidTermsAndConditionUrl'), termsTitle);
    }
  };

  setTermsAndConditionError(errorMessage, termsTitle) {
    this.setState({
      termsAndConditions: {
        error: errorMessage,
        termsTitle
      }
    });
  }

  render({}, { offers, areOffersVisible, isTermsAndCondistionVisible, termsAndConditions }) {
    const isSingleOffer = offers.length === 1;

    return (
      <div>
        {Boolean(offers.length) && (
          <div
            onClick={this.toggleOffersVisibility}
            class={`ptm-pointer-cursor ptm-offer-strip ptm-lightgreen-bg ${
              isSingleOffer ? 'ptm-single-offer' : ''
            }`}
            id="checkout-offers"
          >
            {/* Single offer */}
            {isSingleOffer && offers[0].offer && (
              <span>
                <img class={`ptm-inline-offer-image`} src={offers[0].offer.icon} />
                <div className={`ptm-ex-offer`}>
                  <div>{offers[0].offer.title}</div>
                  <div class={`ptm-small-txt`}>{offers[0].offer.text}</div>
                </div>
              </span>
            )}
            {/* Multiple offers */}
            {offers.length > 1 && (
              <span class={`ptm-multi-offer`}>
                <img
                  src={`${staticPath()}/assets/images/ic-offers.svg`}
                  alt="ptm-ofer-img"
                  className={`ptm-margin0 ptm-ribbon-img `}
                />
                <span>
                  {offers.length} {locale('offers.message')}
                </span>
              </span>
            )}
            <img
              className={`pos-r ptm-margin0 ptm-ex-drop ptm-right`}
              src={`${staticPath()}/assets/images/ic-dropdown-light.svg`}
              alt="dropdown"
            />
          </div>
        )}

        {/* Bank offers details */}
        {areOffersVisible && (
          <OverlayWrap>
            <div className={`ptm-close-wrap ptm-pos-a closeIcon ptm-pointer-cursor`}>
              <span className={`ptm-cross ptm-pos-r`} onClick={this.toggleOffersVisibility} />
            </div>
            <div>
              <h2 class={`ptm-body-bg ptm-offers-header`}>{locale('offers.bankOffers')}</h2>

              <div class={`ptm-content-wrapper`}>
                {offers &&
                  offers.map(offerDetail => (
                    <div class={`ptm-offer-container`}>
                      {offerDetail.offer && (
                        <div>
                          <div class={`ptm-left ptm-pos-r ptm-offer-image ptm-global-border`}>
                            <img className={`ptm-centralized`} src={offerDetail.offer.icon} />
                          </div>
                          <div class={`ptm-offer-details`}>
                            <p class={`ptm-offer-title`}>{offerDetail.offer.title}</p>
                            <p class={`ptm-small-txt`}>{offerDetail.offer.text}</p>
                            {offerDetail.termsUrl && (
                              <p
                                class={`ptm-small-txt-link ptm-offer-tnc`}
                                onClick={() => {
                                  this.showTermsAndConditions(
                                    offerDetail.termsUrl,
                                    offerDetail.termsTitle
                                  );
                                }}
                              >
                                {locale('offers.termsAndCondition')}
                              </p>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </OverlayWrap>
        )}

        {/* Offer terms and conditions */}
        {isTermsAndCondistionVisible && (
          <OverlayWrap>
            <div className={`ptm-close-wrap ptm-pos-a closeIcon ptm-pointer-cursor`}>
              <span className={`ptm-cross ptm-pos-r`} onClick={this.closeTermsAndConditions} />
            </div>
            {termsAndConditions && (
              <div>
                <h2 class={`body-bg ptm-offers-header`}>{termsAndConditions.termsTitle}</h2>
                {termsAndConditions.error && (
                  <div class={`ptm-content-wrapper ptm-tnc-box `}>{termsAndConditions.error}</div>
                )}
                {termsAndConditions.terms && !termsAndConditions.error && (
                  <div class={`ptm-content-wrapper ptm-tnc-box`}>
                    {/* eslint-disable-next-line react/no-danger */}
                    <div dangerouslySetInnerHTML={{ __html: termsAndConditions.terms }} />
                  </div>
                )}
              </div>
            )}
          </OverlayWrap>
        )}
      </div>
    );
  }
}

export default connect('cache')(Offers);



// WEBPACK FOOTER //
// ./components/offers/index.js